import { ISensorInterface } from './ISensorInterface';
import { BaseSensor } from './BaseSensor';
export class SensorSet{

	humiditySensors : Map<string,ISensorInterface>;
	temperatureSensors : Map<string,ISensorInterface>;
	pressureSensors:Map<string,ISensorInterface>;
	airQualitySensors:Map<string,ISensorInterface>;
	ventilationSensors:Map<string,ISensorInterface>;
	miscSensors:Map<string,ISensorInterface>;
	constructor(){
		this.humiditySensors = new Map<string,ISensorInterface>();
		this.temperatureSensors = new Map<string,ISensorInterface>();
		this.pressureSensors = new Map<string,ISensorInterface>();
		this.ventilationSensors = new Map<string,ISensorInterface>();
		this.airQualitySensors = new Map<string,ISensorInterface>();
		this.miscSensors = new Map<string,ISensorInterface>();
	}
	
	getSensor(sensortype : string, sensorname : string):ISensorInterface{
		let s :Map<string,ISensorInterface>;
		switch(sensortype){
			case 'humidity':{
				s=this.humiditySensors;
				break;
			}
			case 'temperature':{
				s=this.temperatureSensors;
				break;
			}
			case 'misc':{
				s=this.miscSensors;
				break;
			}
			case 'pressure':{
				s=this.pressureSensors;
				break;
			}
			case 'airquality':{
				s=this.airQualitySensors;
				break;
			}
			case 'ventilation':{
				s=this.ventilationSensors;
				break;
			}
		}
		if(s == undefined){
			return;
		}
		return s.get(sensorname);
	}


	search(name:string):ISensorInterface{
		if(this.temperatureSensors.has(name)){
			return this.temperatureSensors.get(name);
		}
		if(this.humiditySensors.has(name)){
			return this.humiditySensors.get(name);
		}
		if(this.pressureSensors.has(name)){
			return this.pressureSensors.get(name);
		}
		if(this.airQualitySensors.has(name)){
			return this.airQualitySensors.get(name);
		}
		if(this.ventilationSensors.has(name)){
			return this.ventilationSensors.get(name);
		}
		
	}
	
	addMiscSensor(sensor:ISensorInterface){
		this.miscSensors.set(sensor.getName(),sensor);
	}
	getMiscSensor(name:string):ISensorInterface{
		return this.miscSensors.get(name);
	}

	addVentilationSensor(sensor:ISensorInterface){
		this.ventilationSensors.set(sensor.getName(),sensor);	
	}
	addAirQualitySensor(sensor:ISensorInterface){
		this.airQualitySensors.set(sensor.getName(),sensor);
	}
	
	addPressureSensor(sensor:ISensorInterface){
		this.pressureSensors.set(sensor.getName(),sensor);
	}
	addHumiditySensor(sensor : ISensorInterface){
		this.humiditySensors.set(sensor.getName(),sensor);
	}
	addTemperatureSensor(sensor : ISensorInterface){
		this.temperatureSensors.set(sensor.getName(),sensor);
	}


	getVentilationSensor(name:string):ISensorInterface{
		return this.ventilationSensors.get(name);
	}
	getAirQualitySensor(name:string):ISensorInterface{
		return this.airQualitySensors.get(name);
	}
	getPressureSensor(name:string):ISensorInterface{
		return this.pressureSensors.get(name);
	}
	getHumiditySensor(name:string):ISensorInterface{
		return this.humiditySensors.get(name);
	}
	
	getTemperatureSensor(name:string):ISensorInterface{
		return this.temperatureSensors.get(name);
	}



}

